import React from 'react';

const TopCopy = () => (
  <div className="top-short-content">
    <p className="icon-check-circle">
      <b>List in minutes.</b> Take a few photos. Add a description. Set your
      price.
    </p>
  </div>
);

export default TopCopy;
